module.exports = __webpack_public_path__ + "static/img/avanzado.8c7f7f0c.jpg";